import { AdvanceFilter } from '@/types/types';
import { Button } from './ui/button';
import { FormFieldSelect, Option } from './FormFieldSelect';
import { Input } from './ui/input';
import FormFieldCalendar from './FormFieldCalendar';
import { FormItem } from './ui/form';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { SlidersHorizontal } from 'lucide-react';

export const AdvanceFilterButton = ({
  filters,
  buttonLabel,
  onClick,
}: {
  filters: AdvanceFilter[];
  buttonLabel: string;
  onClick: () => void;
}) => {
  return (
    <Button
      type="button"
      variant="outline"
      className="text-primary h-[36px] py-2 px-4 rounded-md focus:outline-none border-primary hover:bg-[#EDF5FF] flex gap-2"
      onClick={onClick}
    >
      <SlidersHorizontal className="h-[14px] w-[14px]" />
      {buttonLabel}
      {filters.length > 0 && <Badge className="w-[14px] h-[14px] text-[10px] px-2 py-2">{filters.length}</Badge>}
    </Button>
  );
};

export const AdvanceFilterValueField = ({
  inputType,
  name,
  value,
  options,
  onValueChange,
}: {
  inputType: 'SELECT' | 'DATE' | 'INPUT';
  name: string;
  value: string;
  options?: Option[];
  onValueChange: (value: string | undefined) => void;
}) => {
  if (inputType === 'SELECT')
    return (
      <FormFieldSelect
        name={name}
        hasControl={false}
        options={options ?? []}
        defaultValue={value}
        onChange={(value) => onValueChange(value)}
        label="Value"
        placeholder="Select Value"
      />
    );
  if (inputType === 'INPUT')
    return (
      <FormItem className={`flex flex-col gap-1`}>
        <Label htmlFor={name} className="block text-sm font-medium">
          Value
        </Label>
        <Input
          name={name}
          placeholder="Enter Value"
          defaultValue={value}
          onChange={(e) => onValueChange(e.target.value)}
        />
      </FormItem>
    );
  if (inputType === 'DATE')
    return (
      <FormFieldCalendar
        name={name}
        hasControl={false}
        onChange={(date) =>
          onValueChange(
            date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString() : undefined
          )
        }
        defaultValue={value}
        label="Value"
        placeholder="Pick a Value"
      />
    );
};
